import site from '../../extends/site';
const themsInfo = localStorage.getItem('themsInfo') || '{}';
const defaultSite = {
    title: '云枢',
    logo: require('@/assets/images/yslogo.png'),
};
const mix = Object.assign({}, defaultSite, site, JSON.parse(themsInfo));
export default mix;
